import ViewEntityModal from "../../ViewEntityModal";
import { menuItemStyleBlue, menuItemStyleRed } from "./styles";
import EditEntityModal from "../../EditEntityModal";
import DeleteEntityModal from "../../DeleteEntityModal";
import React from "react";

const getActions = ({
  formName,
  isSubaccount,
  groupId,
  shared,
  subNoun = "",
  mainNoun = "",
  customMessage = {},
}) => {
  let actions = [
    {
      label: "View",
      color: "#0071BB",
      action: "test",
      component: (props) => (
        <ViewEntityModal
          id={props.id}
          menuItemStyle={menuItemStyleBlue}
          formName={formName}
          isSubaccount={isSubaccount}
          groupId={groupId}
        />
      ),
    },
  ];
  if (!shared) {
    if (!isSubaccount) {
      actions.push(
        {
          label: "Edit",
          color: "#0071BB",
          action: "test",
          component: (props) => (
            <EditEntityModal
              id={props.id}
              menuItemStyle={menuItemStyleBlue}
              formName={formName}
            />
          ),
        },
        {
          label: "Delete",
          color: "#9C1712",
          action: "test",
          component: (props) => (
            <DeleteEntityModal
              formName={formName}
              id={props.id}
              isMainEntity={true}
              deleteSubNoun={subNoun}
              deleteMainNoun={mainNoun}
              customMessage={customMessage?.delete}
              menuItemStyle={menuItemStyleRed}
            />
          ),
        }
      );
    }
  } else {
    if (!isSubaccount) {
      actions.push(
        {
          label: "Edit",
          color: "#0071BB",
          action: "test",
          component: (props) => (
            <EditEntityModal
              id={props.id}
              menuItemStyle={menuItemStyleBlue}
              formName={formName}
            />
          ),
        },
        {
          label: "Delete",
          color: "#9C1712",
          action: "test",
          component: (props) => (
            <DeleteEntityModal
              id={props.id}
              formName={formName}
              isMainEntity={false}
              customMessage={customMessage?.delete}
              menuItemStyle={menuItemStyleRed}
            />
          ),
        }
      );
    }
  }
  return actions;
};

export default getActions;
